// @ts-nocheck

import React from 'react';
import { useSelector } from 'react-redux';

// Lodash
import isEqual from 'lodash/isEqual';

// Components
import ButtonDropdown from 'app/shared/modules/filter/ButtonDropdownV2';

// Misc / utils
import LabelMaker from 'app/shared/utils/labelMaker';
import { DEFAULT } from 'app/shared/models/Filter';
import './style.scss';

const FilterPresetList = () => {
  const filter = useSelector((state) => state.filter);
  const { price, pets, bedrooms, bathrooms } = filter;
  const { min, max } = price;
  const priceLabel = LabelMaker.price({ min, max }) ?? 'Any price';
  const bedroomLabel = LabelMaker.bedrooms(bedrooms) ?? 'All beds';
  const bathroomLabel = LabelMaker.bathrooms(bathrooms) ?? 'all baths';
  const petsLabel = LabelMaker.pets(pets) ?? 'Pets';

  const isDefaultFilterValue = (category) => {
    return isEqual(filter[category], DEFAULT[category]);
  };

  return (
    <div className="FilterPresetList">
      <ButtonDropdown
        label={priceLabel}
        className="FilterPresetList-item"
        filterModalName="PriceSlider"
        showDoneButton
        filterKeys={['price']}
        theme={isDefaultFilterValue('price') ? 'default' : 'teal'}
      />
      <ButtonDropdown
        label={`${bedroomLabel}, ${bathroomLabel}`}
        className="FilterPresetList-item"
        filterModalName="BedsBathsSelector"
        showDoneButton
        filterKeys={['bedrooms', 'bathrooms']}
        theme={
          isDefaultFilterValue('bedrooms') === false || isDefaultFilterValue('bathrooms') === false ? 'teal' : 'default'
        }
      />
      <ButtonDropdown
        label={petsLabel}
        className="FilterPresetList-item"
        filterModalName="PetsSelector"
        showDoneButton
        filterKeys={['pets']}
        theme={isDefaultFilterValue('pets') ? 'default' : 'teal'}
      />
    </div>
  );
};

export default FilterPresetList;
